import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-1 bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full" }
const _hoisted_2 = { class: "space-y-6 ml-4" }
const _hoisted_3 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "py-3 pr-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_5 = { class: "space-y-6 ml-4 overflow-y-auto" }
const _hoisted_6 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_7 = { class: "pr-6" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_DetailLayout, {
      scrollSidebar: "",
      customClass: "px-0",
      onBack: _ctx.goBack,
      title: _ctx.title,
      loading: _ctx.isLoading,
      error: _ctx.isError,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.getDetail
    }, {
      data: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Title, {
            label: _ctx.$t('stiDest.detail.title')
          }, null, 8, ["label"]),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_DataWrapper, {
              class: "w-6/12",
              label: _ctx.$t('stiDest.detail.partnerName'),
              value: _ctx.detailData.consolidatorName
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-6/12",
              label: _ctx.$t('stiDest.detail.userType'),
              value: _ctx.roleAccount
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-6/12",
              label: _ctx.$t('stiDest.detail.arrivalCity'),
              value: _ctx.detailData.destinationConsolidator
            }, null, 8, ["label", "value"])
          ])
        ]),
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_Title, {
            label: _ctx.$t('stiDest.detail.detailStt')
          }, null, 8, ["label"]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('stiDest.detail.totalStt'),
              class: "w-6/12",
              value: _ctx.formatQuantity(_ctx.detailData.totalStt)
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('stiDest.detail.totalKoli'),
              class: "w-6/12",
              value: _ctx.formatQuantity(_ctx.detailData.totalPiece)
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('stiDest.detail.totalGrossWeight'),
              value: `${_ctx.formatWeight(_ctx.detailData.totalGrossWeight)} Kg`,
              class: "w-6/12"
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('stiDest.detail.totalVolumeWeight'),
              value: `${_ctx.formatWeight(_ctx.detailData.totalVolumeWeight)} Kg`,
              class: "w-6/12"
            }, null, 8, ["label", "value"])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_TableV2, {
              data: _ctx.detailData.stt,
              columns: _ctx.columns,
              borderTop: false,
              hidePagination: true,
              isRightFreeze: true,
              isPinnedScrollBottom: false,
              totalColumnFreeze: 0
            }, null, 8, ["data", "columns"])
          ])
        ])
      ]),
      "sub-data": _withCtx(() => [
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('stiDest.detail.tanggalDibuat'),
          value: _ctx.convertCreatedAt,
          caption: _ctx.detailData.sttCreatedName
        }, null, 8, ["label", "value", "caption"]),
        _hoisted_8,
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('stiDest.detail.printStiDest')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LpButton, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.print('summary'))),
              class: "mt-3 w-48",
              flat: "",
              dense: "",
              iconLeft: "print-summary",
              title: _ctx.$t('stiDest.detail.printSummary')
            }, null, 8, ["title"]),
            _createVNode(_component_LpButton, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.print('manifest'))),
              class: "w-48",
              flat: "",
              iconLeft: "printer",
              dense: "",
              title: _ctx.$t('stiDest.detail.printPdf')
            }, null, 8, ["title"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"])
  ]))
}